var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLockOpen48Line = function SvgIconLockOpen48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4 19.3h-.7V16c0-4.25-3.45-7.7-7.7-7.7s-7.7 3.45-7.7 7.7h3.4c0-2.37 1.93-4.3 4.3-4.3s4.3 1.93 4.3 4.3v3.3H15.6a5.31 5.31 0 0 0-5.3 5.3v9.8c0 2.92 2.38 5.3 5.3 5.3h16.8c2.92 0 5.3-2.38 5.3-5.3v-9.8c0-2.92-2.38-5.3-5.3-5.3Zm1.9 15.1c0 1.05-.85 1.9-1.9 1.9H15.6a1.9 1.9 0 0 1-1.9-1.9v-9.8c0-1.05.85-1.9 1.9-1.9h16.8c1.05 0 1.9.85 1.9 1.9v9.8Z",
    fill: "current"
  })));
};
export default SvgIconLockOpen48Line;